import { Helmet } from 'react-helmet-async';
import React from 'react';

export const SITE_NAME = 'くらべる';

export const DEFAULT_DESCRIPTION =
  '人々の暮らしを楽にするサービスを届け、あなたの大切な時間をつくります。';

type PageMetaProps = {
  title: string;
  description?: string;
  noIndex?: boolean;
};

const PageMeta: React.FC<PageMetaProps> = ({
  title,
  description = DEFAULT_DESCRIPTION,
  noIndex = false,
}) => {
  const fullTitle = title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  );
};

export default PageMeta;
